import { HttpClient } from '@/core/http/http-client';
import { DeleteProfileImageJson } from '@/modules/types';
import { TenantModel } from '../domain';
import { mapTenantJsonToTenantModel, tenantsMapper } from '../mappers';
import {
  ApiResponseTenant,
  ApiResponseTenants,
  TenantJson,
  UpdateTenantNameJson,
} from '../types';
import { TenantRepository } from './tenant.repository';

export class HttpTenantRepository extends TenantRepository {
  constructor(private readonly client: HttpClient) {
    super();
  }

  async getTenants(): Promise<TenantModel[]> {
    const tenants = await this.client.get<ApiResponseTenants<TenantJson[]>>({
      url: `me/by-ids`,
    });

    return tenantsMapper(tenants.data.tenants);
  }

  async getTenantById(tenantId: number): Promise<TenantModel> {
    const tenant = await this.client.get<ApiResponseTenant<TenantJson>>({
      url: `${tenantId}`,
    });

    return mapTenantJsonToTenantModel(tenant.data.tenant);
  }

  async updateTenantName(data: UpdateTenantNameJson): Promise<number> {
    return await this.client.patch<number>(`${data.id}/name`, data);
  }

  async uploadProfilePicture(data: FormData): Promise<unknown> {
    return await this.client.post<unknown>({
      url: `${data.get('EntityId')}/profile-picture`,
      body: data,
    });
  }

  async deleteProfilePicture(data: DeleteProfileImageJson): Promise<unknown> {
    return await this.client.delete<unknown>(
      `${data.entityId}/profile-picture/${data.fileId}`,
    );
  }

  async getProfilePictureById(tenantId: number) {
    return await this.client.get<Blob>({
      url: `${tenantId}/profile-picture`,
      config: {
        responseType: 'blob',
      },
    });
  }
}
